import {
  addLoading,
  hideAlert,
  hideConfirm,
  removeLoading,
  showConfirm,
  showError,
  showSuccess,
  toggleMenu,
} from '@redux/actions';
import {
  createAppKeyAsync,
  deleteAppKeyAsync,
  updateAppKeyAsync,
} from '@redux/actions/apiActions/appKeyApiAction';
import {
  deleteDriverAsync,
  driverApproveBulkAsync,
  driverRegisterAsync,
} from '@redux/actions/apiActions/driverManagementApiAction';
import {
  approveAllPreRegistrationAsync,
  approvePreRegistrationDetailsAsync,
  sendSmsAsync,
  updatePreRegistrationDetailsAsync,
} from '@redux/actions/apiActions/driverTmpApiAction';
import { accountDeleteAsync } from '@redux/actions/apiActions/facilityApiAction';
import { confirmAllNotificationAsync } from '@redux/actions/apiActions/notificationApiAction';
import { registerTempAsync } from '@redux/actions/apiActions/preRegistrationApiAction';
import { forceCheckoutDriverAsync } from '@redux/actions/apiActions/receptionManagementApiAction';
import {
  enableBoxAsync,
  updateLockerNameAsync,
} from '@redux/actions/apiActions/securityBoxApiAction';
import { changeSettingAsync } from '@redux/actions/apiActions/settingApiAction';
import { updateSMSConfigAsync } from '@redux/actions/apiActions/smsApiAction';
import {
  login,
  changePassword,
  forgotPassword,
  forceChangePassword,
} from '@redux/actions/AuthService';
import { createSlice } from '@reduxjs/toolkit';

const initialState: AppState = {
  openMenu: true,
  loadingCount: 0,
  alert: {
    show: false,
    type: 'success',
    message: '',
  },
  dialogConfirm: { show: false },
  checkedIdsState: [],
  previewImageState: '',
  fileImageState: undefined,
  tenantKey: '',
  tenantId: '',
  isFinalApproveSetting: true,
};

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setCheckedIdsState: (state, { payload }) => {
      state.checkedIdsState = payload;
    },
    setPreviewImageState: (state, { payload }) => {
      state.previewImageState = payload;
    },
    setFileImageState: (state, { payload }) => {
      state.fileImageState = payload;
    },
    setTenantKeyState: (state, { payload }) => {
      state.tenantKey = payload;
    },
    setTenantIdState: (state, { payload }) => {
      state.tenantId = payload;
    },
    setIsFinalApproveSettingState: (state, { payload }) => {
      state.isFinalApproveSetting = payload;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(toggleMenu, state => {
        state.openMenu = !state.openMenu;
      })
      .addCase(addLoading, state => {
        state.loadingCount++;
      })
      .addCase(removeLoading, state => {
        state.loadingCount--;
      })
      .addCase(showError, (state, { payload }) => {
        state.alert = {
          show: true,
          type: 'error',
          ...payload,
        };
      })
      .addCase(showSuccess, (state, { payload }) => {
        state.alert = {
          show: true,
          type: 'success',
          ...payload,
        };
      })
      .addCase(hideAlert, state => {
        state.alert.show = false;
      })
      .addCase(showConfirm, (state, { payload }) => {
        state.dialogConfirm = {
          show: true,
          ...payload,
        };
      })
      .addCase(hideConfirm, state => {
        state.dialogConfirm.show = false;
      })
      .addCase(forgotPassword.fulfilled, state => {
        state.alert = {
          show: true,
          type: 'success',
          message: 'MSI00004',
        };
      })
      .addCase(login.fulfilled, (state, { payload }) => {
        if (payload.user.isChangePass) {
          state.alert = {
            show: true,
            type: 'warning',
            message: 'MSW00004',
          };
        }
      })
      .addCase(forceChangePassword.fulfilled, state => {
        state.alert = {
          show: true,
          type: 'success',
          message: 'MSI00005',
        };
      })
      .addCase(login.rejected, state => {
        state.alert = {
          show: true,
          type: 'error',
          message: 'MSE00004',
        };
      })
      .addCase(changePassword.fulfilled, state => {
        state.alert = {
          show: true,
          type: 'success',
          message: 'MSI00003',
        };
      })
      .addCase(driverRegisterAsync.fulfilled, state => {
        state.alert = {
          show: true,
          type: 'success',
          message: 'common.registration_complete',
        };
      })
      .addCase(deleteDriverAsync.fulfilled, state => {
        state.alert = {
          show: true,
          type: 'success',
          message: 'MSI00001',
        };
      })
      .addCase(approveAllPreRegistrationAsync.fulfilled, state => {
        state.alert = {
          show: true,
          type: 'success',
          message: 'MSI00003',
        };
      })
      .addCase(updatePreRegistrationDetailsAsync.fulfilled, state => {
        state.alert = {
          show: true,
          type: 'success',
          message: 'MSI00003',
        };
      })
      .addCase(approvePreRegistrationDetailsAsync.fulfilled, state => {
        state.alert = {
          show: true,
          type: 'success',
          message: 'MSI00003',
        };
      })
      .addCase(driverApproveBulkAsync.fulfilled, state => {
        state.alert = {
          show: true,
          type: 'success',
          message: 'MSI00003',
        };
      })
      .addCase(sendSmsAsync.fulfilled, state => {
        state.alert = {
          show: true,
          type: 'success',
          message: 'MSI00003',
        };
      })
      .addCase(registerTempAsync.fulfilled, state => {
        state.alert = {
          show: true,
          type: 'success',
          message: 'MSI00002',
        };
      })
      .addCase(createAppKeyAsync.fulfilled, state => {
        state.alert = {
          show: true,
          type: 'success',
          message: 'MSI00002',
        };
      })
      .addCase(deleteAppKeyAsync.fulfilled, state => {
        state.alert = {
          show: true,
          type: 'success',
          message: 'MSI00001',
        };
      })
      .addCase(updateAppKeyAsync.fulfilled, state => {
        state.alert = {
          show: true,
          type: 'success',
          message: 'MSI00003',
        };
      })
      .addCase(enableBoxAsync.fulfilled, state => {
        state.alert = {
          show: true,
          type: 'success',
          message: 'MSI00003',
        };
      })
      .addCase(forceCheckoutDriverAsync.fulfilled, state => {
        state.alert = {
          show: true,
          type: 'success',
          message: 'MSI00003',
        };
      })
      .addCase(changeSettingAsync.fulfilled, state => {
        state.alert = {
          show: true,
          type: 'success',
          message: 'MSI00003',
        };
      })
      .addCase(updateSMSConfigAsync.fulfilled, state => {
        state.alert = {
          show: true,
          type: 'success',
          message: 'MSI00003',
        };
      })
      .addCase(confirmAllNotificationAsync.fulfilled, state => {
        state.alert = {
          show: true,
          type: 'success',
          message: 'MSI00003',
        };
      })
      .addCase(updateLockerNameAsync.fulfilled, state => {
        state.alert = {
          show: true,
          type: 'success',
          message: 'MSI00003',
        };
      })
      .addCase(accountDeleteAsync.fulfilled, state => {
        state.alert = {
          show: true,
          type: 'success',
          message: 'MSI00001',
        };
      });
  },
});

export const {
  setCheckedIdsState,
  setPreviewImageState,
  setFileImageState,
  setTenantKeyState,
  setTenantIdState,
  setIsFinalApproveSettingState,
} = appSlice.actions;
export default appSlice.reducer;
